import _extends from "@babel/runtime/helpers/extends";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _taggedTemplateLiteral from "@babel/runtime/helpers/taggedTemplateLiteral";

var _templateObject, _templateObject2;

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { withVDSManager } from '@vds-core/utilities';
import PaginationControls from './PaginationControls';
import PaginationNumbers from './PaginationNumbers';
var propTypes = {
  /**
   * If provided, this callback function will fire when selecting a PaginationLink and accepts the page number as an argument.
   */
  selectPage: PropTypes.func,

  /**
   * This callback function should accept an argument for the page value and returns an href for the anchor elements.
   */
  baseUrl: PropTypes.func,

  /**
   * Selected active page number.
   */
  selectedPage: PropTypes.number,

  /**
   * @ignore
   * Border radius for focus ring
   */
  focusBorderRadius: PropTypes.string,

  /**
   * Total number of pages.
   */
  total: PropTypes.number.isRequired,

  /**
   * @ignore
   */
  children: PropTypes.node,

  /**
   * @ignore
   */
  className: PropTypes.string,

  /**
   * @ignore
   */
  ariaLabel: PropTypes.string,

  /**
   * @ignore
   */
  surface: PropTypes.oneOf(['light', 'dark']),

  /**
   * @ignore
   * A function that receives the currently selectedPage and the total number of pages and returns an object containing the startRange and endRange values to be displayed
   */
  calculateRange: PropTypes.func,

  /**
   * Allows a string to be provided for analytics.
   */
  'data-analyticstrack': PropTypes.string,

  /**
   * Allows a string to be provided for analytics.
   */
  'data-track': PropTypes.string,

  /**
   * Allows a string to be provided for ignoring analytics tagging.
   */
  'data-track-ignore': PropTypes.string,

  /**
   * Allows a string to be provided for click stream.
   */
  'data-clickstream': PropTypes.string,

  /**
   * Allows a string to be provided for analytics tagging.
   */
  'data-sitecat-level': PropTypes.string,

  /**
   * Allows a string to be provided for analytics tagging.
   */
  'data-sitecat-position': PropTypes.string,

  /**
   * Allows a string to be provided for analytics tagging.
   */
  'data-sitecat-datatrack': PropTypes.string,

  /**
   * Allows a string to be provided for analytics tagging.
   */
  'data-sitecat-cta': PropTypes.string,

  /**
   * Allows an id to be passed to the outermost wrapper of the component
   */
  id: PropTypes.string
};
var widthPagination = '288px';
var defaultProps = {
  selectPage: null,
  showArrow: undefined,
  total: 20,
  selectedPage: 10,
  children: null,
  className: null,
  ariaLabel: 'Pagination',
  surface: 'light',
  focusBorderRadius: '2px',
  calculateRange: function calculateRange(selectedPage, total) {
    var additionalPagesToShow = selectedPage < 98 ? 3 : 2;
    var startRange = Math.min(selectedPage - 1, total - additionalPagesToShow);

    if (selectedPage === 1) {
      startRange = 1;
    }

    var endRange = startRange + additionalPagesToShow;
    return {
      startRange: startRange,
      endRange: endRange
    };
  }
};
var StyledNav = /*#__PURE__*/styled.nav.withConfig({
  displayName: "StyledNav",
  componentId: "VDS__sc-1r0l2p6-0"
})(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  width: ", ";\n  &:hover {\n    outline: none;\n  }\n"])), widthPagination);
export var StyledList = /*#__PURE__*/styled.ul.withConfig({
  displayName: "StyledList",
  componentId: "VDS__sc-1r0l2p6-1"
})(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n  margin: 0;\n  padding: 0;\n  display: flex;\n  text-align: center;\n  justify-content: center;\n  align-items: center;\n  white-space: nowrap;\n  list-style-type: none;\n"])));

var Pagination = function Pagination(props) {
  var analyticsTrack = props['data-analyticstrack'],
      track = props['data-track'],
      trackIgnore = props['data-track-ignore'],
      clickStream = props['data-clickstream'],
      cta = props['data-sitecat-cta'],
      dataTrack = props['data-sitecat-datatrack'],
      position = props['data-sitecat-position'],
      level = props['data-sitecat-level'],
      calculateRange = props.calculateRange,
      total = props.total,
      focusBorderRadius = props.focusBorderRadius;

  function _onClick(e) {
    /* istanbul ignore else */
    if (e.type === 'click') {
      e.currentTarget.blur();
    }
  }

  var paginationComponentProps = _objectSpread(_objectSpread({}, props), {}, {
    className: ''
  });

  return /*#__PURE__*/React.createElement(StyledNav, {
    id: props.id,
    tabIndex: -1,
    "aria-label": props.ariaLabel,
    className: props.className,
    onClick: _onClick,
    "data-analyticstrack": analyticsTrack,
    "data-track": track,
    "data-track-ignore": trackIgnore,
    "data-clickstream": clickStream
  }, /*#__PURE__*/React.createElement(StyledList, null, /*#__PURE__*/React.createElement(PaginationControls, _extends({
    total: props.total,
    dataTrack: dataTrack,
    position: position,
    level: level,
    cta: cta,
    focusBorderRadius: focusBorderRadius
  }, paginationComponentProps), /*#__PURE__*/React.createElement(PaginationNumbers, _extends({
    selectPage: props.selectPage,
    selectedPage: props.selectedPage,
    calculateRange: calculateRange,
    total: total,
    focusBorderRadius: focusBorderRadius
  }, paginationComponentProps)))));
};

Pagination.propTypes = propTypes;
Pagination.defaultProps = defaultProps;
export default withVDSManager(Pagination);